import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { PatchUserPreferencesTO } from "src/app/data/schema/User/PatchUserPreferencesTO";
import { ProfileService } from "../../services/profile.service";

@Component({
    selector: "app-profile-preferences",
    templateUrl: "./profile-preferences.component.html",
    styleUrls: ["./profile-preferences.component.scss"]
})
export class ProfilePreferencesComponent implements OnInit, OnDestroy {
    private userSubscription: Subscription;

    public loading$: Observable<boolean>;
    public editMode: boolean;
    public cardData: PatchUserPreferencesTO;

    constructor(private profileService: ProfileService) {
        this.editMode = false;
        this.cardData = {
            idioma: "",
            mostrarEmail: false,
            deixarCursosVisiveis: false
        };

        this.loading$ = this.profileService.getLoadingAsync();

        this.userSubscription = this.profileService.getUserAsync().subscribe((user) => {
            if (user) {
                this.cardData = {
                    idioma: user.preferencias?.idioma,
                    mostrarEmail: user.preferencias?.mostrarEmail,
                    deixarCursosVisiveis: user.preferencias?.deixarCursosVisiveis
                };
            }
        });
    }

    ngOnInit(): void {
        this.profileService.getLoggedUser();
    }

    ngOnDestroy(): void {
        this.userSubscription.unsubscribe();
        this.profileService.clear();
    }

    getShowEmailText = (): string => {
        return this.cardData.mostrarEmail ? "SETTINGS.MESSAGES.SHOW_EMAIL_TRUE" : "SETTINGS.MESSAGES.SHOW_EMAIL_FALSE";
    };

    getShowCoursesText = (): string => {
        return this.cardData.deixarCursosVisiveis
            ? "SETTINGS.MESSAGES.SHOW_COURSES_TRUE"
            : "SETTINGS.MESSAGES.SHOW_COURSES_FALSE";
    };

    toggleEdition(): void {
        if (this.editMode) {
            this.save();
        }

        this.editMode = !this.editMode;
    }

    private save(): void {
        this.profileService.updateUserPreferences(this.cardData);
    }
}
